export default {
  bind(el: any, binding: any) {
    if (typeof binding.value !== 'function') {
      const warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function`;
    }

    const handler = (e) => {
      if (!el.contains(e.target) && el !== e.target) {
        binding.value();
      }
    };
    el.__vueClickOutside__ = handler;

    // add Event Listeners
    document.addEventListener('click', handler);
  },

  unbind(el: any, binding: any) {
    document.removeEventListener('click', el.__vueClickOutside__);
    el.__vueClickOutside__ = null;
  },
};
